// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable multiline-comment-style */
import type { TrackingAction, TrackingModule } from "./trackingEventTypes"

// MODULES
export const GeneralModule: TrackingModule = "general"
export const InsuranceModule: TrackingModule = "insurance"
export const RefundModule: TrackingModule = "refund"
export const CoronaRefundModule: TrackingModule = "corona refund"
export const ContactDetailsModule: TrackingModule = "contact details"
export const InvoiceModule: TrackingModule = "invoice"
export const AncillaryModule: TrackingModule = "ancillary"
export const PaymentModule: TrackingModule = "payment"
export const SpecialAssistanceModule: TrackingModule = "special assistance"
export const SportsEquipmentsModule: TrackingModule = "sports equipments"
export const PetPassengersModule: TrackingModule = "pet passengers"
export const MusicalInstrumentsModule: TrackingModule = "musical instruments"
export const ItineraryChangeModule: TrackingModule = "itinerary change"
export const BoardingPassesModule: TrackingModule = "boarding passes"
export const FareTypesModule: TrackingModule = "fare types"
export const ServicePackageModule: TrackingModule = "service package"
export const BookingLockedModule: TrackingModule = "booking locked"
export const Guarantee2Module: TrackingModule = "guarantee 2"
export const MMB2Module: TrackingModule = "mmb2"
export const MMB1EaseOfUse: TrackingModule = "nps feedback"
export const HiddenCitiesModule: TrackingModule = "hidden cities"
export const PaidGuaranteeModule: TrackingModule = "paid guarantee"

// Common actions
export const UIAction = {
  buttonClicked: "button clicked",
  bannerDisplayed: "banner displayed",
  tileClicked: "tile clicked",
  optionsDisplayed: "options displayed",
} as const

export enum ErrorAction {
  invalidData = "invalid data",
}

export const GeneralAction = {
  error: "error",
  success: "success",
} as const

export const APIAction = {
  GET_DATA_REQUESTED: "get data requested",
  GET_DATA_FAILED: "get data failed",
  GET_DATA_SUCCEEDED: "get data succeeded",
  POST_DATA_REQUESTED: "post data requested",
  POST_DATA_FAILED: "post data failed",
  POST_DATA_SUCCEEDED: "post data succeeded",
  PATCH_DATA_REQUESTED: "patch data requested",
  PATCH_DATA_FAILED: "patch data failed",
  PATCH_DATA_SUCCEEDED: "patch data succeeded",
  SUBMIT_SUCCESSFUL: "submit successful",
  REDIRECTED_TO_LOGIN: "redirected to login page",
} as const

export type Action =
  | typeof UIAction[keyof typeof UIAction]
  | typeof GeneralAction[keyof typeof GeneralAction]
  | ErrorAction

/*
 * ACTIONS - for manual tracking via mmbTrack.js
 * pls always make actions in convention noun + verb (e.g. button clicked)
 */
export const ContinueClickAction: TrackingAction = {
  action: "continue clicked",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}
export const ModalOpenAction: TrackingAction = {
  action: "modal opened",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}
export const InvalidDataReceiveAction: TrackingAction = {
  action: "invalid data received",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}
export const ErrorOccurredAction: TrackingAction = {
  action: "error occurred",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const FormSubmitAction: TrackingAction = {
  action: "form submitted",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const ButtonClickAction: TrackingAction = {
  action: "button clicked",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const PartSelectAction: TrackingAction = {
  action: "part selected",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const HiddenCitiesGuideBannerDisplayed: TrackingAction = {
  action: "hidden cities guide banner displayed",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const EmailCorrectionAction: TrackingAction = {
  action: "email corrected",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true },
}

export const UnexpectedServerResponseAction: TrackingAction = {
  action: "unexpected data received from be",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true },
}
export const BookingLoadRetryAction: TrackingAction = {
  action: "booking load retried",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const ServicePackageRulesetReceiveAction: TrackingAction = {
  action: "service package ruleset received",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: false },
}

export const RefundReasonDisplayAction: TrackingAction = {
  action: "refund reason displayed",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const RefundReasonChooseAction: TrackingAction = {
  action: "refund reason chosen",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const RefundRequestAction: TrackingAction = {
  action: "refund requested",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const AlertDisplayedAction: TrackingAction = {
  action: "alert displayed",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const RafSubmitAction: TrackingAction = {
  action: "raf submitted",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const RedirectAction: TrackingAction = {
  action: "redirected to another url",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const DeeplinkOpenAction: TrackingAction = {
  action: "modal opened from deeplink",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const UnknownDeeplinkAction: TrackingAction = {
  action: "deeplink unknown value",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const UnknownToastAction: TrackingAction = {
  action: "toast unknown value",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}

export const TileClickAction: TrackingAction = {
  action: "tile clicked",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: true },
}

/*
 * DETAILS
 */
export const USInsuranceRefundLink = "us insurance refund link"
export const USInsuranceRefundConfirm = "us insurance refund confirm"

/*
 * API ACTIONS - for tracking via promise.js middleware
 * there actions are used in actionTypesToEventMapper.js
 * we cannot add verb at the end in action, because the verb will be filled in by track.js middleware
 */
export const PostFormAction: TrackingAction = {
  action: "post form",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: true, datadog: true },
}
export const GetDataAction: TrackingAction = {
  action: "get data",
  destinations: { logmole: true, exponea: false, ga: false, bigQuery: false, datadog: true },
}

// Guarantee 2.0 Events

export const createGT2TrackingAction = (options: { action: string }): TrackingAction => ({
  ...options,
  destinations: {
    logmole: true,
    bigQuery: true,
    datadog: true,
    ga: false,
    exponea: false,
  },
})

export const MmbEaseOfUseSurveyRatingGivenAction: TrackingAction = {
  action: "rate saved",
  module: "mmb1",
  destinations: { logmole: false, exponea: false, ga: false, bigQuery: true, datadog: true },
}
